import {
  HIDE_SCORECARD_REQUIRED_MODAL,
  SHOW_SCORECARD_REQUIRED_MODAL,
} from './constants';
import { ScorecardRequirement } from './types';

export interface ShowScorecardRequiredModalAction {
  type: typeof SHOW_SCORECARD_REQUIRED_MODAL;
  requirement: ScorecardRequirement;
}

export interface HideScorecardRequiredModalAction {
  type: typeof HIDE_SCORECARD_REQUIRED_MODAL;
}

export type ScorecardRequiredModalAction =
  | ShowScorecardRequiredModalAction
  | HideScorecardRequiredModalAction;

export function showScorecardRequiredModal(
  requirement: ScorecardRequirement,
): ShowScorecardRequiredModalAction {
  return {
    type: SHOW_SCORECARD_REQUIRED_MODAL,
    requirement,
  };
}

export function hideScorecardRequiredModal(): HideScorecardRequiredModalAction {
  return {
    type: HIDE_SCORECARD_REQUIRED_MODAL,
  };
}
